import { useMutation } from "@tanstack/react-query";
import { apiCall } from "../lib/apiClient";
import {
  gdprErasureResponseSchema,
  type GdprErasureResponse,
} from "../schemas/gdprErasure";

/**
 * Phase 32 REQ-COMP-001 — POST /api/admin/users/{userId}/erase.
 *
 * Mutation triggers cascade redact + final audit row. UI renderuje completion
 * screen (audit pointer) po úspěchu. Errors mapped na REQ-API-012 `error_code`:
 *   - GDPR_USER_NOT_FOUND
 *   - GDPR_INVALID_PAYLOAD
 *   - GDPR_ERASURE_RETRY_EXHAUSTED
 */
export function useGdprErasureMutation() {
  return useMutation<GdprErasureResponse, Error, { userId: string }>({
    mutationFn: async ({ userId }) => {
      const raw = await apiCall<unknown>(
        `/api/admin/users/${encodeURIComponent(userId)}/erase`,
        { method: "POST" },
      );
      return gdprErasureResponseSchema.parse(raw);
    },
  });
}
